
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Viktor Wächter, 80, verstorben am 5. April 2020</b>
    <br />
    <br />
    <i>Sein Sohn Roland Wächter erzählt:</i>
    <br />
    <p>
  «Das Coronavirus hat unsere Familie hart getroffen. Wir waren in einem
  absoluten Ausnahmezustand. Unsere Geschichte soll den Menschen die
  Gefährlichkeit dieses Virus vor Augen führen.
    </p>
    <p>
  Am 18. März arbeitete ich das letzte Mal zusammen mit meinem Vater in seinem
  geliebten Rebberg. Fünf Tage später hatten er und meine Mutter die ersten
  Symptome. Zuerst hielten sie es für eine Magen-Darm-Grippe. Am Tag darauf traf
  es mich – ich verlor den Geschmacks- und den Geruchssinn. Auch meine Frau
  wurde krank. Es fing mit starkem Kopfweh an, dann kamen hohes Fieber und
  schlimme Muskelschmerzen dazu.
    </p>
    <p>
  Der Zustand meiner Eltern verschlechterte sich rapide. Am 29. März brachten
  wir die beiden ins Spital auf die Notfallstation. Mein Vater kam wegen
  extremer Atemnot auf die Intensivstation. Intubiert werden wollte er aber
  nicht – er sagte den Ärzten, die Beatmungsmaschinen müssten für die Jungen
  frei bleiben. Obwohl es zu dem Zeitpunkt noch genügend Maschinen gehabt hätte.
  Aber so war er.
    </p>
    <p>
  Wir mussten am Telefon von ihm Abschied nehmen. Wenn du weisst, dass du diese
  vertraute Stimme nie mehr hörst – das ist unendlich schmerzhaft. Es hilft mir
  aber, zu wissen, dass er ein schönes, selbstbestimmtes Leben hatte. Er war
  jahrelang Chefmonteur beim Kabelwerk Brugg – die Schweiz ist auch wegen ihm so
  gut elektrifiziert. Darauf war er sehr stolz.
    </p>
    <p>
  Er ahnte wohl, dass er nach der Erkrankung nicht hätte in seinen Rebberg
  zurückkehren können. Seine Lunge war zu stark geschädigt. So wollte er lieber
  gehen. Am 5. April nahm er seine Sauerstoffmaske selbst ab.
    </p>
    <p>
  Am Gedenkgottesdienst, der zu Ehren der Verstorbenen vom vergangenen Jahr in
  unserer Gemeinde stattfand, hätte ein Posaunenchor auf der Empore spielen
  sollen. Auch für meinen Vater. Doch wegen der Corona-Massnahmen war dies nicht
  möglich. Nicht einmal alle Familienmitglieder durften dabei sein. Ich habe
  mich geärgert, als ich diese Woche die Bilder aus dem Parlament gesehen habe.
  Die Parlamentarier feiern dort und machen einen auf lustig. Was sind das für
  Vorbilder!
    </p>
    <p>
  Für meine Mutter waren die ganzen Umstände und sein Tod traumatisch.
  Körperlich hat sie sich vom Virus einigermassen erholt. Doch die psychischen
  Schmerzen bleiben. Die beiden waren 60 Jahre verheiratet, wurden gemeinsam ins
  Spital eingeliefert, und als sie wieder nach Hause kam, stand noch die
  Kaffeetasse meines Vaters auf dem Tisch.»
    </p>
  <iframe height='200px' width='100%' frameBorder='no' scrolling='no' seamless src='https://player.simplecast.com/736867d8-8cad-4c6b-808d-cc759edbaaa0?dark=true&color=121212' style={{
      marginTop: '2em'
    }}></iframe>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;